import OriginalButton from './Button.svelte';
import Loader from './Loader.svelte';
import Icon from './Icon.svelte';
const Button = OriginalButton;
Button.Loader = Loader;
Button.Icon = Icon;
Button.Leading = Icon;
Button.Trailing = Icon;
export default Button;
